/**
 * Stato e avviso della correzione automatica di <birthdate-input>.
 *
 * Il componente riporta ai bound una data fuori range e pubblica `corrected`:
 * qui si tiene traccia di quali campi sono in quello stato (per il bordo di
 * attenzione) e si avvisa l'utente. Senza l'avviso la prenotazione partirebbe
 * con una data di nascita che nessuno ha scelto, e il mismatch col documento
 * salta fuori solo al check-in.
 *
 * Condiviso fra i form passeggeri di liveflight e alpitour: la correzione e'
 * la stessa, cambia solo da dove arriva l'eta' dichiarata.
 */

import { reverse_date } from '@/utilities/commons';
import { declared_age_label } from '@/utilities/birthdate';

// Il default del toast (10s) non basta a leggere un messaggio di questa lunghezza.
const CORRECTION_TOAST_MS = 18000;

/**
 * @param {{from: string, to: string}} correction come la pubblica il componente
 * @param {number|null} age eta' dichiarata, null se i bound sono quelli di fascia
 * @returns {string} markup del toast (data ed eta' in grassetto)
 */
export const birthdate_correction_message = (correction, age) => {
  let mismatch = "non è compatibile con l'età indicata in fase di ricerca";
  if (age !== null && age !== undefined) {
    mismatch = `non corrisponde all'età di <b>${declared_age_label(
      age
    )}</b> indicata in fase di ricerca`;
  }
  return `Attenzione. Abbiamo aggiornato la data di nascita a una data valida per l'età che hai dichiarato, perché quella inserita (<b>${reverse_date(
    correction.from
  )}</b>) ${mismatch}. Controlla che sia corretta, oppure avvia una nuova ricerca con l'età giusta.`;
};

export const birthdate_correction_mixin = {
  data() {
    return {
      // chiave del campo -> {from, to, user_edited}, null appena l'utente mette
      // le mani sul campo: e' lo stato "corretto e non ancora ricontrollato".
      birthdate_corrections: {},
    };
  },
  methods: {
    birthdate_correction(key) {
      return this.birthdate_corrections[String(key)] || null;
    },
    notify_birthdate_correction(key, correction, age = null) {
      this.birthdate_corrections = {
        ...this.birthdate_corrections,
        [String(key)]: correction,
      };
      if (!correction) {
        return;
      }
      // Fuori dal flush: la correzione arriva da un watcher di
      // <birthdate-input>, mentre ogni altro toast parte da una callback async.
      this.$nextTick(() => {
        window.eventBus.$emit('got_toast_notification', {
          text: birthdate_correction_message(correction, age),
          timer: CORRECTION_TOAST_MS,
          variant: 'warning',
        });
      });
    },
  },
};
